(function () {
  var SELECTORS = {
    section: '[data-section-type="back-in-stock"]',
    variantSelects: 'variant-selects[data-section], variant-radios[data-section]',
    variantJson: 'script[type="application/json"]',
    variantInput: 'input[name="id"]',
    mainSubmit: '[id^="ProductSubmitButton-"]',
    stickySubmit: '[id^="StickyAtcSubmitButton-"]'
  };
  var FORCE_VISIBLE_CLASS = 'bisn-force-visible';

  function toBoolean(value) {
    return String(value) === 'true';
  }

  function parseInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function getPubSubEvents() {
    if (typeof PUB_SUB_EVENTS !== 'undefined') return PUB_SUB_EVENTS;
    if (typeof window !== 'undefined' && window.PUB_SUB_EVENTS) return window.PUB_SUB_EVENTS;
    return null;
  }

  function createDebugLogger(sectionId) {
    var query = '';

    try {
      query = window.location.search;
    } catch (error) {
      query = '';
    }

    var enabled =
      query.indexOf('bisn_debug=1') !== -1 ||
      query.indexOf('variant_debug=1') !== -1 ||
      (typeof window !== 'undefined' &&
        window.localStorage &&
        window.localStorage.getItem('bisn_debug') === '1');

    function log(level, message, data) {
      if (!enabled || !window.console) return;

      var method = console[level] || console.log;
      if (typeof data === 'undefined') {
        method.call(console, '[BISN][' + sectionId + '] ' + message);
      } else {
        method.call(console, '[BISN][' + sectionId + '] ' + message, data);
      }
    }

    return {
      enabled: enabled,
      log: function (message, data) {
        log('log', message, data);
      },
      warn: function (message, data) {
        log('warn', message, data);
      },
      error: function (message, data) {
        log('error', message, data);
      }
    };
  }

  var BISNApi = {
    subscribe: function subscribe(params) {
      if (!params.publicKey) {
        return Promise.reject(new Error('missing_public_key'));
      }

      if (!params.variantId) {
        return Promise.reject(new Error('missing_variant'));
      }

      return fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(params.publicKey),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-02-15'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: params.email
                    }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: '$shopify:::$default:::' + String(params.variantId)
                  }
                }
              }
            }
          })
        }
      ).then(function (response) {
        if (response.ok) return response;

        return response.text().then(function (text) {
          var error = new Error(text || 'request_failed');
          error.status = response.status;
          throw error;
        });
      });
    }
  };

  function BISNPopup(section) {
    this.section = section;
    this.dataset = section.dataset;
    this.sectionId = this.dataset.sectionId || 'unknown';
    this.debug = createDebugLogger(this.sectionId);
    this.modal = section.querySelector('[data-bisn-modal]');
    this.overlay = section.querySelector('[data-bisn-overlay]');
    this.closeButton = section.querySelector('[data-bisn-close]');
    this.form = section.querySelector('[data-bisn-form]');
    this.emailInput = section.querySelector('[data-bisn-email]');
    this.errorNode = section.querySelector('[data-bisn-error]');
    this.submitButton = section.querySelector('[data-bisn-submit]');
    this.spinner = section.querySelector('[data-bisn-spinner]');
    this.states = section.querySelectorAll('[data-bisn-state]');
    this.contentColumn = section.querySelector('.bisn__col--content');
    this.hideAtc = toBoolean(this.dataset.hideAtc);
    this.publicKey = this.dataset.klaviyoPublicKey || '';
    this.autoCloseDelay = parseInteger(this.dataset.autoClose, 0);
    this.notifyBtnLabelMobile = this.dataset.notifyBtnLabelMobile || '';
    this.submitLabelMobile = this.dataset.submitLabelMobile || '';
    this.currentVariant = null;
    this.mainNotifyButton = null;
    this.stickyNotifyButton = null;
    this.autoCloseTimer = null;
    this.variantInputObserver = null;
    this.boundVariantInput = null;
    this.unsubscribeVariantChange = null;
    this.lastActiveElement = null;
    this.variantData = [];
    this.variantById = new Map();
    this.handleVariantInputChange = function () {
      this._syncVariantFromDom('variant input change');
    }.bind(this);
    this.nativeKlaviyoCleanupTimers = [];
    this.availableRestoreTimers = [];

    this.debug.log('initializing', {
      hideAtc: this.hideAtc,
      hasPublicKey: !!this.publicKey,
      autoCloseDelay: this.autoCloseDelay
    });

    this._resolveProductContext();

    if (!this.productSectionId || !this.mainButton) {
      this.debug.warn('product context not resolved', {
        productSectionId: this.productSectionId || null,
        hasVariantSelects: !!this.variantSelects,
        hasMainButton: !!this.mainButton
      });
      return;
    }

    this._injectNotifyButtons();
    this._applyMobileLabels();
    this._bindEvents();
    this._syncVariantFromDom('init');
  }

  BISNPopup.prototype._resolveProductContext = function _resolveProductContext() {
    var mainButton = this.productSectionId
      ? document.getElementById('ProductSubmitButton-' + this.productSectionId)
      : document.querySelector(SELECTORS.mainSubmit);

    if (!mainButton) return;

    this.mainButton = mainButton;
    this.productSectionId = mainButton.id.replace('ProductSubmitButton-', '');
    this.stickyButton = document.getElementById('StickyAtcSubmitButton-' + this.productSectionId);
    this.stickyAtc = document.getElementById('sticky-atc-' + this.productSectionId);
    this.variantSelects =
      document.getElementById('variant-selects-' + this.productSectionId) ||
      document.querySelector('variant-selects[data-section="' + this.productSectionId + '"], variant-radios[data-section="' + this.productSectionId + '"]');
    this.productForm =
      document.getElementById('product-form-' + this.productSectionId) ||
      document.querySelector('product-form[data-section="' + this.productSectionId + '"]');
    this.variantInput =
      (this.productForm && this.productForm.querySelector(SELECTORS.variantInput)) ||
      document.querySelector('#product-form-' + this.productSectionId + ' ' + SELECTORS.variantInput) ||
      document.querySelector('.product-form .product-variant-id');

    this.variantData = this._getVariantData();
    this.variantById = new Map();

    this.variantData.forEach(
      function (variant) {
        this.variantById.set(String(variant.id), variant);
      }.bind(this)
    );

    this.debug.log('resolved product context', {
      productSectionId: this.productSectionId,
      hasStickyButton: !!this.stickyButton,
      hasStickyAtc: !!this.stickyAtc,
      hasVariantSelects: !!this.variantSelects,
      hasVariantInput: !!this.variantInput,
      variantCount: this.variantData.length
    });
  };

  BISNPopup.prototype._refreshProductContext = function _refreshProductContext() {
    var previousMainButton = this.mainButton;
    var previousStickyButton = this.stickyButton;
    var previousVariantInput = this.variantInput;

    this._resolveProductContext();

    if (!this.productSectionId || !this.mainButton) {
      this.debug.warn('product context refresh failed');
      return false;
    }

    this._injectNotifyButtons();

    if (this.variantInput !== previousVariantInput) {
      this._bindVariantInputEvents();
    }

    if (previousMainButton !== this.mainButton || previousStickyButton !== this.stickyButton) {
      this.debug.log('product context refreshed', {
        mainButtonReplaced: previousMainButton !== this.mainButton,
        stickyButtonReplaced: previousStickyButton !== this.stickyButton
      });
    }

    return true;
  };

  BISNPopup.prototype._getVariantData = function _getVariantData() {
    if (!this.variantSelects) return [];

    var jsonNode = this.variantSelects.querySelector(SELECTORS.variantJson);
    if (!jsonNode) {
      this.debug.warn('variant JSON script not found');
      return [];
    }

    try {
      return JSON.parse(jsonNode.textContent);
    } catch (error) {
      this.debug.error('failed to parse variant JSON', error);
      return [];
    }
  };

  BISNPopup.prototype._injectNotifyButtons = function _injectNotifyButtons() {
    if (this.mainButton) {
      var mainNotifyButtons = Array.prototype.slice.call(
        document.querySelectorAll('.bisn__notify-btn:not(.bisn__notify-btn--sticky)')
      );
      var notifyButton = this.mainNotifyButton && this.mainNotifyButton.isConnected
        ? this.mainNotifyButton
        : mainNotifyButtons[0];

      if (!notifyButton) {
        notifyButton = this._buildNotifyButton(false);
      }

      if (notifyButton.previousElementSibling !== this.mainButton) {
        this.mainButton.insertAdjacentElement('afterend', notifyButton);
      }

      mainNotifyButtons.forEach(function (button) {
        if (button !== notifyButton) {
          button.remove();
        }
      });

      this.mainNotifyButton = notifyButton;
    }

    this.debug.log('notify buttons injected', {
      hasMainNotifyButton: !!this.mainNotifyButton,
      hasStickyNotifyButton: !!this.stickyNotifyButton
    });
  };

  BISNPopup.prototype._isMobile = function _isMobile() {
    return window.innerWidth <= 749;
  };

  BISNPopup.prototype._getNotifyLabel = function _getNotifyLabel() {
    var mobileLabel = this.notifyBtnLabelMobile;
    if (this._isMobile() && mobileLabel) return mobileLabel;
    return this.dataset.notifyBtnLabel || 'Notify me';
  };

  BISNPopup.prototype._getSubmitLabel = function _getSubmitLabel() {
    var mobileLabel = this.submitLabelMobile;
    if (this._isMobile() && mobileLabel) return mobileLabel;
    return null;
  };

  BISNPopup.prototype._applyMobileLabels = function _applyMobileLabels() {
    var notifyLabel = this._getNotifyLabel();
    if (this.mainNotifyButton) this.mainNotifyButton.textContent = notifyLabel;
    if (this.stickyNotifyButton) this.stickyNotifyButton.textContent = notifyLabel;

    var submitLabel = this._getSubmitLabel();
    if (submitLabel && this.submitButton) {
      var labelNode = this.submitButton.querySelector('[data-bisn-submit-label]');
      if (labelNode) labelNode.textContent = submitLabel;
    }
  };

  BISNPopup.prototype._buildNotifyButton = function _buildNotifyButton(isSticky) {
    var button = document.createElement('button');
    button.type = 'button';
    button.hidden = true;
    button.className =
      'bisn__notify-btn atc-button product-form__submit button button--full-width button--margin-x' +
      (isSticky ? ' bisn__notify-btn--sticky' : '');
    button.textContent = this._getNotifyLabel();
    button.addEventListener('click', this.openModal.bind(this));
    return button;
  };

  BISNPopup.prototype._bindEvents = function _bindEvents() {
    if (this.notifyBtnLabelMobile || this.submitLabelMobile) {
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(this._applyMobileLabels.bind(this), 150);
      }.bind(this));
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.closeModal.bind(this));
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', this.closeModal.bind(this));
    }

    if (this.form) {
      this.form.addEventListener('submit', this._handleSubmit.bind(this));
    }

    document.addEventListener(
      'keydown',
      function (event) {
        if (event.code === 'Escape' && this.isOpen()) {
          this.closeModal();
        }
      }.bind(this)
    );

    if (this.variantSelects) {
      this.variantSelects.addEventListener(
        'change',
        function () {
          this._syncVariantFromDom('variant-selects change');
        }.bind(this)
      );
      this.variantSelects.addEventListener(
        'input',
        function () {
          this._syncVariantFromDom('variant-selects input');
        }.bind(this)
      );
    }

    if (this.variantInput) {
      this._bindVariantInputEvents();
    }

    var pubSubEvents = getPubSubEvents();
    if (typeof subscribe === 'function' && pubSubEvents && pubSubEvents.variantChange) {
      this.unsubscribeVariantChange = subscribe(
        pubSubEvents.variantChange,
        function (event) {
          if (!event || !event.data || String(event.data.sectionId) !== String(this.productSectionId)) return;

          this.currentVariant = event.data.variant || null;
          this.debug.log('pubsub variant change', {
            source: 'pubsub',
            variantId: this.currentVariant && this.currentVariant.id,
            available: this.currentVariant && this.currentVariant.available
          });
          this._toggleButtons(!!(this.currentVariant && this.currentVariant.available), !!this.currentVariant, 'pubsub');
        }.bind(this)
      );
    } else {
      this.debug.warn('pubsub variant subscription unavailable', {
        hasSubscribe: typeof subscribe === 'function',
        hasPubSubEvents: !!pubSubEvents
      });
    }
  };

  BISNPopup.prototype._bindVariantInputEvents = function _bindVariantInputEvents() {
    if (!this.variantInput || this.variantInput === this.boundVariantInput) return;

    if (this.boundVariantInput) {
      this.boundVariantInput.removeEventListener('change', this.handleVariantInputChange);
    }

    if (this.variantInputObserver) {
      this.variantInputObserver.disconnect();
    }

    this.boundVariantInput = this.variantInput;
    this.variantInput.addEventListener('change', this.handleVariantInputChange);

    this.variantInputObserver = new MutationObserver(
      function () {
        this._syncVariantFromDom('variant input mutation');
      }.bind(this)
    );

    this.variantInputObserver.observe(this.variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  };

  BISNPopup.prototype._syncVariantFromDom = function _syncVariantFromDom(source) {
    if (!this._refreshProductContext()) return;

    var variant = null;
    var selectedId = this.variantInput && this.variantInput.value ? String(this.variantInput.value) : '';

    if (selectedId && this.variantById.has(selectedId)) {
      variant = this.variantById.get(selectedId);
    } else if (!this.variantSelects && selectedId) {
      variant = this._buildFallbackVariant(selectedId);
    } else {
      variant = this._findVariantFromOptions();
    }

    this.currentVariant = variant || null;

    this.debug.log('resolved variant', {
      source: source || 'unknown',
      selectedId: selectedId || null,
      variantId: variant && variant.id,
      available: variant && variant.available
    });

    this._toggleButtons(!!(variant && variant.available), !!variant, source || 'unknown');
  };

  BISNPopup.prototype._buildFallbackVariant = function _buildFallbackVariant(selectedId) {
    var available = !this.mainButton || !this.mainButton.hasAttribute('disabled');
    var fallbackVariant = {
      id: selectedId,
      available: available
    };

    this.debug.log('using fallback variant', fallbackVariant);

    return fallbackVariant;
  };

  BISNPopup.prototype._findVariantFromOptions = function _findVariantFromOptions() {
    if (!this.variantData.length || !this.variantSelects) return null;

    var selectedOptions = [];

    this.variantSelects.querySelectorAll('.product-form__input').forEach(function (inputWrapper) {
      var typeNode = inputWrapper.querySelector('.product-form__input__type');
      if (!typeNode) return;

      var fieldType = typeNode.dataset.type;
      var selectedValue = '';

      if (fieldType === 'dropdown' || fieldType === 'dropdwon') {
        var select = inputWrapper.querySelector('select');
        selectedValue = select ? select.value : '';
      } else {
        var checked = inputWrapper.querySelector('input[type="radio"]:checked, option:checked');
        selectedValue = checked ? checked.value : '';
      }

      selectedOptions.push(selectedValue);
    });

    return (
      this.variantData.find(function (variant) {
        if (!variant || !variant.options || variant.options.length !== selectedOptions.length) return false;

        return variant.options.every(function (optionValue, index) {
          return optionValue === selectedOptions[index];
        });
      }) || null
    );
  };

  BISNPopup.prototype._getMainNotifyButtons = function _getMainNotifyButtons() {
    var buttons = Array.prototype.slice.call(
      document.querySelectorAll('.bisn__notify-btn:not(.bisn__notify-btn--sticky)')
    );

    if (!buttons.length && this.mainNotifyButton) {
      buttons.push(this.mainNotifyButton);
    }

    return buttons.filter(function (button) {
      return button && button.isConnected;
    });
  };

  BISNPopup.prototype._getStickyNotifyButtons = function _getStickyNotifyButtons() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll('.bisn__notify-btn--sticky'));

    if (!buttons.length && this.stickyNotifyButton) {
      buttons.push(this.stickyNotifyButton);
    }

    return buttons.filter(function (button) {
      return button && button.isConnected;
    });
  };

  BISNPopup.prototype._isVisible = function _isVisible(element) {
    return !!(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
  };

  BISNPopup.prototype._suppressNativeKlaviyoBis = function _suppressNativeKlaviyoBis() {
    document.querySelectorAll('#klaviyo-bis-button-container, [id^="klaviyo-bis-button-container"]').forEach(
      function (container) {
        container.hidden = true;
        container.setAttribute('aria-hidden', 'true');
        container.style.display = 'none';
      }
    );

    var hasVisibleCloseButton = false;

    Array.prototype.slice.call(document.querySelectorAll('.klaviyo-close-form')).forEach(
      function (button) {
        if (this._isVisible(button)) {
          hasVisibleCloseButton = true;
          button.click();
        }
      }.bind(this)
    );

    if (!hasVisibleCloseButton) {
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
    }
  };

  BISNPopup.prototype._scheduleNativeKlaviyoBisSuppression = function _scheduleNativeKlaviyoBisSuppression() {
    this._clearNativeKlaviyoBisSuppression();

    [0, 150, 500, 1000].forEach(
      function (delay) {
        var timer = window.setTimeout(this._suppressNativeKlaviyoBis.bind(this), delay);
        this.nativeKlaviyoCleanupTimers.push(timer);
      }.bind(this)
    );
  };

  BISNPopup.prototype._clearNativeKlaviyoBisSuppression = function _clearNativeKlaviyoBisSuppression() {
    this.nativeKlaviyoCleanupTimers.forEach(function (timer) {
      window.clearTimeout(timer);
    });
    this.nativeKlaviyoCleanupTimers = [];
  };

  BISNPopup.prototype._clearAvailableButtonRestore = function _clearAvailableButtonRestore() {
    this.availableRestoreTimers.forEach(function (timer) {
      window.clearTimeout(timer);
    });
    this.availableRestoreTimers = [];
  };

  BISNPopup.prototype._getSelectedVariant = function _getSelectedVariant() {
    var selectedId = this.variantInput && this.variantInput.value ? String(this.variantInput.value) : '';

    if (selectedId && this.variantById.has(selectedId)) {
      return this.variantById.get(selectedId);
    }

    if (selectedId && this.currentVariant && String(this.currentVariant.id) === selectedId) {
      return this.currentVariant;
    }

    if (!selectedId && this.currentVariant) {
      return this.currentVariant;
    }

    return null;
  };

  BISNPopup.prototype._restoreAvailableButtons = function _restoreAvailableButtons() {
    if (!this._refreshProductContext()) return;

    var selectedVariant = this._getSelectedVariant();

    if (!selectedVariant || selectedVariant.available !== true) {
      return;
    }

    var mainButtons = [this.mainButton].filter(Boolean);
    var stickyButtons = [this.stickyButton].filter(Boolean);
    var stickyContainers = [this.stickyAtc].filter(Boolean);
    var notifyButtons = this._getMainNotifyButtons().concat(this._getStickyNotifyButtons());

    notifyButtons.forEach(function (button) {
      button.hidden = true;
      button.setAttribute('aria-hidden', 'true');
    });

    mainButtons.concat(stickyButtons).forEach(
      function (button) {
        this._showButton(button);
        button.classList.add(FORCE_VISIBLE_CLASS);
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        delete button.dataset.bisnOriginalDisabled;
      }.bind(this)
    );

    stickyContainers.forEach(this._showElement.bind(this));
  };

  BISNPopup.prototype._scheduleAvailableButtonRestore = function _scheduleAvailableButtonRestore() {
    this._clearAvailableButtonRestore();

    [0, 150, 500, 1000].forEach(
      function (delay) {
        var timer = window.setTimeout(this._restoreAvailableButtons.bind(this), delay);
        this.availableRestoreTimers.push(timer);
      }.bind(this)
    );
  };

  BISNPopup.prototype._toggleButtons = function _toggleButtons(isAvailable, hasVariant, source) {
    if (!this._refreshProductContext()) return;

    var mainButtons = [this.mainButton].filter(Boolean);
    var stickyButtons = [this.stickyButton].filter(Boolean);
    var stickyContainers = [this.stickyAtc].filter(Boolean);
    var mainNotifyButtons = this._getMainNotifyButtons();
    var stickyNotifyButtons = this._getStickyNotifyButtons();

    if (!hasVariant) {
      this._clearAvailableButtonRestore();
      this._clearNativeKlaviyoBisSuppression();

      mainNotifyButtons.forEach(function (button) {
        button.hidden = true;
      });
      stickyNotifyButtons.forEach(function (button) {
        button.hidden = true;
      });

      mainButtons.concat(stickyButtons).forEach(
        function (button) {
          button.classList.remove(FORCE_VISIBLE_CLASS);
          this._showButton(button);
          if (button.dataset.bisnOriginalDisabled === 'true') {
            button.setAttribute('disabled', 'disabled');
          } else {
            button.removeAttribute('disabled');
          }
        }.bind(this)
      );
      stickyContainers.forEach(this._showElement.bind(this));

      this.debug.log('button state applied', {
        source: source,
        hasVariant: false,
        isAvailable: false,
        hideAtc: this.hideAtc
      });
      return;
    }

    if (isAvailable) {
      this._clearNativeKlaviyoBisSuppression();
      this._restoreAvailableButtons();
      this._scheduleAvailableButtonRestore();

      this.debug.log('button state applied', {
        source: source,
        hasVariant: true,
        isAvailable: true,
        hideAtc: this.hideAtc
      });
      return;
    }

    this._clearAvailableButtonRestore();

    mainNotifyButtons.forEach(function (button, index) {
      button.hidden = index !== 0;
      button.toggleAttribute('aria-hidden', index !== 0);
    });
    stickyNotifyButtons.forEach(function (button) {
      button.hidden = true;
      button.setAttribute('aria-hidden', 'true');
    });

    mainButtons.forEach(
      function (button) {
        button.classList.remove(FORCE_VISIBLE_CLASS);

        if (button.dataset.bisnOriginalDisabled === undefined) {
          button.dataset.bisnOriginalDisabled = button.hasAttribute('disabled') ? 'true' : 'false';
        }

        if (this.hideAtc) {
          this._hideButton(button);
          button.removeAttribute('disabled');
        } else {
          this._showButton(button);
          button.setAttribute('disabled', 'disabled');
        }
      }.bind(this)
    );

    stickyButtons.forEach(
      function (button) {
        button.classList.remove(FORCE_VISIBLE_CLASS);

        if (button.dataset.bisnOriginalDisabled === undefined) {
          button.dataset.bisnOriginalDisabled = button.hasAttribute('disabled') ? 'true' : 'false';
        }

        this._showButton(button);
        button.removeAttribute('disabled');
      }.bind(this)
    );
    stickyContainers.forEach(this._hideElement.bind(this));

    this._scheduleNativeKlaviyoBisSuppression();

    this.debug.log('button state applied', {
      source: source,
      hasVariant: true,
      isAvailable: false,
      hideAtc: this.hideAtc
    });
  };

  BISNPopup.prototype._hideButton = function _hideButton(button) {
    if (!button) return;
    this._hideElement(button);
  };

  BISNPopup.prototype._showButton = function _showButton(button) {
    this._showElement(button);
  };

  BISNPopup.prototype._hideElement = function _hideElement(element) {
    if (!element) return;
    element.classList.remove(FORCE_VISIBLE_CLASS);
    element.hidden = true;
    element.setAttribute('aria-hidden', 'true');
    element.style.display = 'none';
  };

  BISNPopup.prototype._showElement = function _showElement(element) {
    if (!element) return;
    element.hidden = false;
    element.removeAttribute('aria-hidden');
    element.style.removeProperty('display');
  };

  BISNPopup.prototype._switchState = function _switchState(state) {
    this.states.forEach(function (node) {
      node.hidden = node.getAttribute('data-bisn-state') !== state;
    });

    if (this.contentColumn) {
      this.contentColumn.classList.toggle('bisn__col--success', state === 'success');
    }

    window.clearTimeout(this.autoCloseTimer);

    if (state === 'success' && this.autoCloseDelay > 0) {
      this.autoCloseTimer = window.setTimeout(
        function () {
          this.closeModal();
        }.bind(this),
        this.autoCloseDelay * 1000
      );
    }

    this.debug.log('state switched', {
      state: state,
      autoCloseDelay: this.autoCloseDelay
    });
  };

  BISNPopup.prototype._setLoading = function _setLoading(isLoading) {
    if (!this.submitButton) return;

    this.submitButton.toggleAttribute('aria-disabled', isLoading);
    this.submitButton.classList.toggle('loading', isLoading);

    if (this.spinner) {
      this.spinner.classList.toggle('hidden', !isLoading);
    }

    this.debug.log('loading state', { isLoading: isLoading });
  };

  BISNPopup.prototype._renderError = function _renderError(message) {
    if (!this.errorNode) return;
    this.errorNode.hidden = !message;
    this.errorNode.textContent = message || '';
    this.debug.warn('rendered error', { message: message || null });
  };

  BISNPopup.prototype._handleSubmit = function _handleSubmit(event) {
    event.preventDefault();

    var email = this.emailInput ? this.emailInput.value.trim() : '';

    this.debug.log('submit attempt', {
      hasPublicKey: !!this.publicKey,
      variantId: this.currentVariant && this.currentVariant.id,
      emailLength: email.length
    });

    if (!isValidEmail(email)) {
      this._renderError(this.dataset.errorText || 'Something went wrong. Please try again.');
      return;
    }

    if (!this.currentVariant || !this.currentVariant.id) {
      this._renderError(this.dataset.missingVariantText || this.dataset.errorText || 'Please select a variant first.');
      return;
    }

    this._renderError('');
    this._setLoading(true);

    BISNApi.subscribe({
      email: email,
      variantId: this.currentVariant.id,
      publicKey: this.publicKey
    })
      .then(
        function (response) {
          this.debug.log('subscription request succeeded', {
            status: response && response.status
          });
          this._switchState('success');
        }.bind(this)
      )
      .catch(
        function (error) {
          this.debug.error('subscription request failed', error);

          if (error && error.message === 'missing_public_key') {
            this._renderError(this.dataset.missingPublicKeyText || this.dataset.errorText || 'Something went wrong. Please try again.');
            return;
          }

          if (error && error.message === 'missing_variant') {
            this._renderError(this.dataset.missingVariantText || this.dataset.errorText || 'Please select a variant first.');
            return;
          }

          this._renderError(this.dataset.errorText || 'Something went wrong. Please try again.');
        }.bind(this)
      )
      .finally(
        function () {
          this._setLoading(false);
        }.bind(this)
      );
  };

  BISNPopup.prototype.openModal = function openModal() {
    if (!this.currentVariant || this.currentVariant.available) {
      this.debug.warn('modal open skipped', {
        hasVariant: !!this.currentVariant,
        available: this.currentVariant && this.currentVariant.available
      });
      return;
    }

    this.lastActiveElement = document.activeElement;
    this._renderError('');
    this._switchState('form');

    if (this.form) {
      this.form.reset();
    }

    if (this.overlay) {
      this.overlay.classList.add('bisn__overlay--active');
    }

    if (this.modal) {
      this.modal.classList.add('bisn__modal--active');
      this.modal.setAttribute('aria-hidden', 'false');
    }

    document.body.classList.add('bisn-modal-open');

    if (typeof trapFocus === 'function' && this.modal) {
      trapFocus(this.modal, this.emailInput || this.closeButton || this.modal);
    } else if (this.emailInput) {
      this.emailInput.focus();
    }

    this.debug.log('modal opened', {
      variantId: this.currentVariant && this.currentVariant.id
    });
  };

  BISNPopup.prototype.closeModal = function closeModal() {
    window.clearTimeout(this.autoCloseTimer);

    if (this.overlay) {
      this.overlay.classList.remove('bisn__overlay--active');
    }

    if (this.modal) {
      this.modal.classList.remove('bisn__modal--active');
      this.modal.setAttribute('aria-hidden', 'true');
    }

    document.body.classList.remove('bisn-modal-open');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.lastActiveElement || this.mainNotifyButton || this.mainButton || document.body);
    } else if (this.lastActiveElement && typeof this.lastActiveElement.focus === 'function') {
      this.lastActiveElement.focus();
    }

    this.debug.log('modal closed');
  };

  BISNPopup.prototype.isOpen = function isOpen() {
    return !!(this.modal && this.modal.classList.contains('bisn__modal--active'));
  };

  function initSections(root) {
    (root || document).querySelectorAll(SELECTORS.section).forEach(function (section) {
      if (section.dataset.bisnInitialized === 'true') return;
      section.dataset.bisnInitialized = 'true';
      new BISNPopup(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSections(document);
    });
  } else {
    initSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });
})();
